import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withTranslation from '../../../hoc/withTranslation';
import { fetchApp } from '../../../store/apps/actions';
import {
    deleteAchievement,
    deleteAchievementPicture,
    getAchievements,
    postAchievementPicture,
    postAchievementUnearnedPicture,
    deleteAchievementUnearnedPicture,
} from '../../../store/achievements/actions';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import styles from './AchievementPage.css';
import style from '../../../styles/styles';
import AdminService, { ADMIN } from '../../../services/admin';
import IconMenu from 'material-ui/IconMenu';
import { Link } from 'react-router-dom';
import { EDIT_ACHIEVEMENT_PAGE, GAMIFICATIONS_PAGE } from '../../../constants/routes';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import AchievementInfo from '../../../components/achievement/AchievementInfo/AchievementInfo';
import Dropzone from 'react-dropzone';
import { Avatar } from 'material-ui';
import { getUserAchievements } from '../../../store/userachievements/actions';
import UserAchievementList
    from '../../../components/achievement/UserAchievementList/UserAchievementList';
import { getCustomFields } from '../../../store/customfields/actions';
import CustomFieldService from '../../../services/customfield';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class AchievementPage extends React.Component {
    static supportedDropFiles = 'image/jpeg, image/png';
    static propTypes = {
        app: PropTypes.object,
        achievements: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string,
        achievementsSending: PropTypes.bool,
        t: PropTypes.func,
        getAchievements: PropTypes.func,
        getUserAchievements: PropTypes.func,
        deleteAchievement: PropTypes.func,
        postAchievementPicture: PropTypes.func,
        deleteAchievementPicture: PropTypes.func,
        postAchievementUnearnedPicture: PropTypes.func,
        deleteAchievementUnearnedPicture: PropTypes.func,
        userAchievementsPending: PropTypes.bool,
        userAchievements: PropTypes.array,
        userAchievementsError: PropTypes.string,
        getCustomFields: PropTypes.func,
        customFields: PropTypes.arrayOf(PropTypes.object),
    };

    state = {
        openRemoveAchievement: false,
        openRemoveAchievementPicture: false,
        openRemoveAchievementUnearnedPicture: false,
        achievement: null,
        uploadingFiles: [],
    };

    handlePictureDrop = (accepted, rejected) => {
        this.setState({ uploadingFiles: [] });

        accepted.forEach((picture) => {
            this.setState({ uploadingFiles: [] });
            console.log('Uploading file ' + picture.name);
            this.props.postAchievementPicture(
                this.props.app,
                this.state.achievement,
                picture,
                this.props.currentLang,
                (progressEvent) => {
                    const percentCompleted = Math.round((
                        progressEvent.loaded * 100
                    ) / progressEvent.total);
                    const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media
                        !== picture);
                    console.log(picture.name
                        + ' -> '
                        + percentCompleted
                        + '% ('
                        + progressEvent.loaded
                        + ' / '
                        + progressEvent.total
                        + ')');
                    this.setState({
                        uploadingFiles: [
                            ...uploadingState,
                            {
                                picture: picture,
                                percent: percentCompleted,
                            },
                        ],
                    });
                },
            )
                .then(() => {
                    this.setState({
                        achievement: this.props.achievements[this.props.currentLang].find(this.compareAchievementId),
                    });
                });
        });
    };

    handleUnearnedPictureDrop = (accepted, rejected) => {
        this.setState({ uploadingFiles: [] });

        accepted.forEach((picture) => {
            this.setState({ uploadingFiles: [] });
            console.log('Uploading file ' + picture.name);
            this.props.postAchievementUnearnedPicture(
                this.props.app,
                this.state.achievement,
                picture,
                this.props.currentLang,
                (progressEvent) => {
                    const percentCompleted = Math.round((
                        progressEvent.loaded * 100
                    ) / progressEvent.total);
                    const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media
                        !== picture);
                    console.log(picture.name
                        + ' -> '
                        + percentCompleted
                        + '% ('
                        + progressEvent.loaded
                        + ' / '
                        + progressEvent.total
                        + ')');
                    this.setState({
                        uploadingFiles: [
                            ...uploadingState,
                            {
                                picture: picture,
                                percent: percentCompleted,
                            },
                        ],
                    });
                },
            )
                .then(() => {
                    this.setState({
                        achievement: this.props.achievements[this.props.currentLang].find(this.compareAchievementId),
                    });
                });
        });
    };

    compareAchievementId = (ac) => {
        return ac.id === this.props.match.params.achievementId;
    };

    componentWillMount() {
        this.fetchApplication(this.props.match.params.appId);
        if (this.props.achievements[this.props.currentLang].length > 0) {
            this.setState({
                achievement: this.props.achievements[this.props.currentLang]
                    .find(this.compareAchievementId),
            });
        }
        if (this.props.app && this.props.currentLang) {
            this.props.getUserAchievements(
                this.props.app,
                this.props.currentLang,
                'json',
                null,
                this.props.match.params.achievementId,
            );

        }
    }

    componentWillReceiveProps(nextProps) {
        const lang = nextProps.currentLang;
        if ((
            this.props.match !== nextProps.match || !this.props.app
        ) && !nextProps.appPending) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (nextProps.app && !this.state.achievement && !nextProps.achievementsPending) {
            if (nextProps.achievements[lang].length > 0) {
                this.setState({
                    achievement: nextProps.achievements[lang].find(function (ac) {
                        return ac.id === nextProps.match.params.achievementId;
                    }),
                });
            } else {
                this.props.getAchievements(nextProps.app, lang);
            }
            if (!this.props.userAchievementsPending && !nextProps.userAchievementsPending) {
                nextProps.getUserAchievements(
                    nextProps.app,
                    nextProps.currentLang,
                    'json',
                    null,
                    nextProps.match.params.achievementId,
                );
            }
        }

        if (nextProps.app && !nextProps.customFields) {
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    renderInformation() {
        return (
            <div
                style={style.col}
                className="col-xs-12 col-sm-12 col-md-12"
            >
                <div className="row" style={{ justifyContent: 'center' }}>
                    <div className="col-xs-12 col-sm-12 col-md-3">
                        <p style={styles.label}>
                            {this.props.t('module.gamification.earned_picture')}
                        </p>
                        <Dropzone
                            ref={(node) => {
                                this.dropzoneRef = node;
                            }}
                            accept={AchievementPage.supportedDropFiles}
                            onDrop={this.handlePictureDrop}
                            multiple={false}
                            style={{}}
                        >
                            <Avatar
                                icon={this.state.achievement.picture && <img
                                    src={this.state.achievement.picture}
                                    alt=""
                                    style={style.image.contain}
                                />}
                                size={75}
                                backgroundColor={grey400}
                                style={styles.avatar}
                            />
                        </Dropzone>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-3">

                        <p style={styles.label}>
                            {this.props.t('module.gamification.unearned_picture')}
                        </p>
                        <Dropzone
                            ref={(node) => {
                                this.dropzoneRef = node;
                            }}
                            accept={AchievementPage.supportedDropFiles}
                            onDrop={this.handleUnearnedPictureDrop}
                            multiple={false}
                            style={{}}
                        >
                            <Avatar
                                icon={this.state.achievement.unearned_picture && <img
                                    src={this.state.achievement.unearned_picture}
                                    alt=""
                                    style={style.image.contain}
                                />}
                                size={75}
                                backgroundColor={grey400}
                                style={styles.avatar}
                            />
                        </Dropzone>
                    </div>
                </div>
                {
                <AchievementInfo
                    achievement={this.state.achievement}
                    lang={this.props.currentLang}
                    app={this.props.app}
                    customFields={CustomFieldService.filter(
                        this.props.customFields,
                        CustomFieldService.ACHIEVEMENT,
                    )}
                />
                }
            </div>
        );
    }

    handleOpenRemoveAchievement = () => {
        this.setState({ openRemoveAchievement: true });
    };

    handleCloseRemoveAchievement = () => {
        this.setState({ openRemoveAchievement: false });
    };

    handleOpenDeleteAchievementPicture = () => {
        this.setState({ openRemoveAchievementPicture: true });
    };
    handleCloseDeleteAchievementPicture = () => {
        this.setState({ openRemoveAchievementPicture: false });
    };
    handleOpenDeleteAchievementUnearnedPicture = () => {
        this.setState({ openRemoveAchievementUnearnedPicture: true });
    };
    handleCloseDeleteAchievementUnearnedPicture = () => {
        this.setState({ openRemoveAchievementUnearnedPicture: false });
    };

    handleRemoveAchievement = () => {
        this.props.deleteAchievement(this.props.app, this.state.achievement, this.props.currentLang)
            .then(() => {
                this.props.history.push(GAMIFICATIONS_PAGE.replace(':appId', this.props.app.id));
            });
    };

    handleRemoveAchievementPicture = () => {
        this.props.deleteAchievementPicture(
            this.props.app,
            this.state.achievement,
            this.props.currentLang,
        )
            .then(() => {
                this.setState({
                    openRemoveAchievementPicture: false,
                    achievement: this.props.achievements[this.props.currentLang]
                        .find(this.compareAchievementId),
                });
            });
    };

    handleRemoveAchievementUnearnedPicture = () => {
        this.props.deleteAchievementUnearnedPicture(
            this.props.app,
            this.state.achievement,
            this.props.currentLang,
        )
            .then(() => {
                this.setState({
                    openRemoveAchievementUnearnedPicture: false,
                    achievement: this.props.achievements[this.props.currentLang]
                        .find(this.compareAchievementId),
                });
            });
    };

    renderDeleteAchievementDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.achievementsSending}
                onClick={this.handleCloseRemoveAchievement}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.achievementsSending}
                onClick={this.handleRemoveAchievement}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveAchievement}
                onRequestClose={this.handleCloseRemoveAchievement}
            >
                {this.props.achievementsSending && <Loading paper={false} />}
                {!this.props.achievementsSending &&
                    <p>{this.props.t('module.gamification.delete_achievement_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderDeleteAchievementPictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.achievementsSending}
                onClick={this.handleCloseDeleteAchievementPicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.achievementsSending}
                onClick={this.handleRemoveAchievementPicture}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveAchievementPicture}
                onRequestClose={this.handleCloseDeleteAchievementPicture}
            >
                {this.props.achievementsSending && <Loading paper={false} />}
                {!this.props.achievementsSending &&
                    <p>{this.props.t('module.gamification.delete_achievement_picture_confirmation')}</p>
                }
            </Dialog>
        );
    }
    renderDeleteAchievementUnearnedPictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.achievementsSending}
                onClick={this.handleCloseDeleteAchievementUnearnedPicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.achievementsSending}
                onClick={this.handleRemoveAchievementUnearnedPicture}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveAchievementUnearnedPicture}
                onRequestClose={this.handleCloseDeleteAchievementUnearnedPicture}
            >
                {this.props.achievementsSending && <Loading paper={false} />}
                {!this.props.achievementsSending &&
                    <p>{this.props.t('module.gamification.delete_achievement_picture_confirmation')}</p>
                }
            </Dialog>
        );
    }


    renderMenu() {
        let menu;
        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    targetOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                >
                    <Link
                        to={EDIT_ACHIEVEMENT_PAGE
                            .replace(':appId', this.props.app.id)
                            .replace(':achievementId', this.state.achievement.id)
                        }
                    >
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenRemoveAchievement}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                    {this.state.achievement.picture &&
                        <MenuItem onClick={this.handleOpenDeleteAchievementPicture}>
                            {this.props.t('module.gamification.remove_earned_picture')}
                        </MenuItem>}
                    {this.state.achievement.unearned_picture &&
                        <MenuItem onClick={this.handleOpenDeleteAchievementUnearnedPicture}>
                            {this.props.t('module.gamification.remove_unearned_picture')}
                        </MenuItem>}
                </IconMenu>
            );
        }

        return menu;
    };

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (
            this.props.app === undefined
            || this.props.app === null
            || this.state.achievement === undefined
            || this.state.achievement === null
        ) {
            return <Loading paper={false} />;
        }
        return (
            <div style={styles.container}>
                {this.renderMenu()}
                {this.renderDeleteAchievementDialog()}
                {this.renderDeleteAchievementPictureDialog()}
                {this.renderDeleteAchievementUnearnedPictureDialog()}
                <h3 style={style.navigation}>{this.props.t('module.gamification.achievements')} / {this.props.t(
                    'generic.detail')} - {this.state.achievement.name}</h3>
                <div className="row">
                    {this.renderInformation()}

                    <div
                        style={styles.list.userAchievementContainer}
                        className="col-xs-12 col-sm-12 col-md-12"
                    >
                        {this.props.userAchievementsPending && <Loading paper={false} />}
                        {!this.props.userAchievementsPending
                            && !this.props.userAchievementsError
                            && this.props.userAchievements
                            && <UserAchievementList
                                app={this.props.app}
                                userAchievements={this.props.userAchievements}
                                title={this.props.t('module.gamification.user_achievements')}
                                lang={this.props.currentLang}
                                achievementId={this.state.achievement
                                    ? this.state.achievement.id
                                    : this.state.achievement}
                            />
                        }
                    </div>
                </div>
            </div>
        );
    };
}

function mapStateToProps(state, ownProps) {
    let props = {
        appPending: state.apps.pending,
        error: state.apps.error || state.achievements.error,
        app: state.apps.currentApplication,
        achievementsPending: state.achievements.pending,
        achievementsSending: state.achievements.sending,
        achievements: state.achievements.content,
        currentLang: state.ui.currentLang,
        user: state.auth.content,
        userAchievementsPending: state.userAchievements.pending,
        userAchievements: state.userAchievements.content,
        userAchievementsError: state.userAchievements.error,
        customFields: state.customFields.content,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    getAchievements,
    getUserAchievements,
    deleteAchievement,
    postAchievementPicture,
    deleteAchievementPicture,
    postAchievementUnearnedPicture,
    deleteAchievementUnearnedPicture,
    getCustomFields,
})(withRouter(withTranslation(AchievementPage)));



// WEBPACK FOOTER //
// src/containers/gamification/AchievementPage/AchievementPage.js